import React, { useState, useEffect } from 'react';
import { Modal, Button, Card, Badge, Spinner } from 'react-bootstrap';
import { fetchPaymentMethodsByEntity } from '../services/api';

// --- Icons ---
const CardIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" /></svg>;

function PaymentMethodsModal({ show, onHide, entityId, entityName }) {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // --- Load Data ---
  useEffect(() => {
    if (show && entityId) {
      loadPaymentMethods();
    }
  }, [show, entityId]);

  const loadPaymentMethods = async () => {
    setIsLoading(true);
    try {
      const response = await fetchPaymentMethodsByEntity(entityId);
      if (response.data && response.data.success) {
        let items = response.data.data.items || response.data.data || [];
        // Sort: Default card first
        items.sort((a, b) => (b.isDefault === true) - (a.isDefault === true));
        setPaymentMethods(items);
      }
    } catch (error) {
      console.error("Error loading payment methods:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="h5 fw-bold text-dark">
          Payment Methods {entityName ? `- ${entityName}` : ''}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-light p-4">
        <>

          {isLoading ? (
            <div className="text-center py-3"><Spinner animation="border" size="sm" variant="primary" /></div>
          ) : paymentMethods.length === 0 ? (
            <div className="text-center text-muted small">No payment methods found for this entity.</div>
          ) : (
            <div className="d-flex flex-column gap-3">
              {paymentMethods.map(method => (
                <div key={method.id} className="border rounded p-3 bg-white d-flex justify-content-between align-items-start">
                  <div className="d-flex gap-3">
                    <div className="mt-1 text-secondary"><CardIcon /></div>
                    <div>
                      <div className="fw-bold d-flex align-items-center gap-2">
                        {method.cardType ? method.cardType.toUpperCase() : 'CARD'} •••• {method.last4}
                        {method.isDefault && <Badge bg="primary" style={{ fontSize: '0.65rem' }}>Default</Badge>}
                      </div>
                      <div className="text-muted small mt-1">{method.name || 'Card'}</div>
                      <div className="text-muted small">Expires {String(method.expiryMonth).padStart(2, '0')}/{String(method.expiryYear).slice(-2)}</div>
                      <div className="small text-muted mt-1">
                        <strong>Billing Address:</strong> {method.addressLine1}, {method.city}, {method.state}, {method.country} {method.postalCode}
                      </div>
                    </div>
                  </div>
                  {/* Removed Edit/Delete Buttons */}
                </div>
              ))}
            </div>
          )}
        </>
      </Modal.Body>

      <Modal.Footer className="bg-light border-0">
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PaymentMethodsModal;